import * as React from 'react';
import { Message, Messages, MessageCategory } from '../../models';
import { List } from 'semantic-ui-react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { MessageItemReadView } from '../MessageItem/MessageItemReadView';


export interface DisplayMessagesProps {
  messages: Messages;
  messageCategories: MessageCategory[];
  isEditMessagesInProgress: boolean;
  hasSearchQuery: boolean;
  categoryName: string;
  editMessageRequest(message: Message): void;
  deleteMessageRequest(id: number): void;
  copyMessage(id: number): void;
  cancelEditMessage(): void;
  sortMessageRequest(oldIndex: number, newIndex: number, categoryName: string): void;
}
const MessageSortableItem = SortableElement((props: any) => {
  const { editMessageRequest,
     id, message,
    messageCategories,
    copyMessage, deleteMessageRequest } = props.value;
  return (
    <ul className="cannedMessageGroupItems">

         <MessageItemReadView
                key={message.id}
                message={message}
                id={id}
                copyMessage={copyMessage}
                deleteMessageRequest={deleteMessageRequest}
                editMessageRequest={editMessageRequest}
                messageCategories={messageCategories}
         />
      </ul>);
});


const getNoResultFoundMessage = () => {
  return (
    <List.Item className="noRecordsContainer">
      <List.Header id="subHeader">
        No records found.
      </List.Header>
    </List.Item>

  );
};


const MessagesSortableList = SortableContainer((props: any) => {
  const { messages, editMessageRequest, deleteMessageRequest, copyMessage,
    cancelEditMessage,
    isEditMessagesInProgress, hasSearchQuery, messageCategories,
     } = props;
  return (
    <List divided={true} selection={true} verticalAlign="middle">

      {messages.length ? messages.map((value: any, index: number) => {

        const itemProps = {
          isEditMessagesInProgress,
          copyMessage,
          cancelEditMessage,
          deleteMessageRequest,
          editMessageRequest,
          hasSearchQuery,
          messageCategories,
          id: index,
          message: value,
        };

        return (<MessageSortableItem
          key={`item-${index}`}
          index={index}
          value={itemProps}
        />);
      })
        : getNoResultFoundMessage()
      }
    </List>
  );
});

export class DisplayMessages extends React.Component<DisplayMessagesProps, {}> {



  getMessageList = () => {
    const { messages, copyMessage, 
      deleteMessageRequest, editMessageRequest, 
       messageCategories,
       } = this.props;

    return (
      <ul className="cannedMessageGroupItems">

        {
          (messages.length ?
            messages.map((message, index) =>
              <MessageItemReadView
                key={message.id}
                message={message}
                id={index}
                copyMessage={copyMessage}
                deleteMessageRequest={deleteMessageRequest}
                editMessageRequest={editMessageRequest}
                messageCategories={messageCategories}
              />)
            : getNoResultFoundMessage())
        }


      </ul>
    );
  }

  onSortEnd = (context: any, trustedContext: any) => {
    this.props.sortMessageRequest(context.oldIndex, context.newIndex, this.props.categoryName);
  }

  render() {
    return (
      <div>
        {
          !this.props.isEditMessagesInProgress ?
            <MessagesSortableList
              useDragHandle={this.props.hasSearchQuery}
              onSortEnd={this.onSortEnd}
              distance={1}
              {...this.props}
            />
            : this.getMessageList()}

      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DisplayMessages/DisplayMessages.tsx